module.exports = __webpack_public_path__ + "img/NP.82dd123d.png";